import groupBy from 'lodash/groupBy';
import React, { useEffect, useState } from 'react';
import { MarkerClusterer } from '@react-google-maps/api';

import VehicleMarker, {
  VehicleMarkerType,
  getMarkerType,
  hasInspectTasks,
} from './vehicle-marker';

const iconStyle = (
  color = 'blue',
  opacity = 0.9,
  strokeWidth = 3,
  size = null,
  inspect = false,
) => {
  const sizeString = size ? ` width="${size}" height="${size}"` : '';
  const textString = inspect
    ? '<text x="50" y="50" text-anchor="middle" fill="black" font-family="Roboto sans-serif" font-size="75" font-weight="bold" dy=".3em">i</text>'
    : '<text />';
  const svgString = `
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg"${sizeString}>
      <circle cx="50" cy="50" r="${
  50 - strokeWidth
}" fill="${color}" stroke="black" stroke-width="${strokeWidth}" opacity="${opacity}" />
      ${textString}
  </svg>`;
  return `data:image/svg+xml;base64,${window.btoa(svgString)}`;
};

const clusterStyle = (encoded) => [
  {
    url: encoded,
    height: 40,
    width: 40,
  },
  {
    url: encoded,
    height: 50,
    width: 50,
  },
  {
    url: encoded,
    height: 60,
    width: 60,
  },
];

const MAX_ZOOM_FOR_CLUSTER = 19;

const clusterTypes = {
  0: 'NORMAL',
  1: 'REGULAR',
  2: 'URGENT',
};
const clusterColors = {
  0: '#5BC2E7',
  1: '#E5FF00',
  2: '#E2231A',
};

function VehicleMarkers({
  vehicles,
  onClick,
  onClose,
  selectedVehicleId,
  setOneTask,
  fetchOneTask,
  isClustered,
  openVehicleForm,
}) {
  const [vehicleClusters, setVehicleClusters] = useState({
    [VehicleMarkerType.REGULAR]: [],
    [VehicleMarkerType.REGULAR_PICKUP]: [],
    [VehicleMarkerType.URGENT_PICKUP]: [],
  });

  useEffect(() => {
    setVehicleClusters(groupBy(vehicles, getMarkerType));
  }, [vehicles.map(({ _id }) => `[${_id}]`).join('-')]);

  return (
    <>
      {isClustered
        ? Object.keys(vehicleClusters).map((vehicleType) => (
          <MarkerClusterer
            key={clusterTypes[vehicleType]}
            averageCenter
            enableRetinaIcons
            maxZoom={MAX_ZOOM_FOR_CLUSTER}
            gridSize={30}
            zoomOnClick
            styles={
              clusterStyle(iconStyle(clusterColors[vehicleType], Number(vehicleType)
                ? 0.9
                : 0.4))
            }
          >
            {(clusterer) => vehicleClusters[vehicleType].map((vehicle, i) => (
              <VehicleMarker
                key={vehicle._id}
                vehicle={vehicle}
                onClick={onClick}
                onClose={onClose}
                zIndex={i + 1 + (hasInspectTasks(vehicle.tasks) ? 1 : 0)}
                fetchOneTask={fetchOneTask}
                setOneTask={setOneTask}
                isSelected={selectedVehicleId === vehicle._id}
                clusterer={clusterer}
                openVehicleForm={openVehicleForm}
              />
            ))}
          </MarkerClusterer>
        ))
        : vehicles.map((vehicle, i) => (
          <VehicleMarker
            key={vehicle._id}
            vehicle={vehicle}
            onClick={onClick}
            onClose={onClose}
            zIndex={i + 1 + (hasInspectTasks(vehicle.tasks) ? 1 : 0)}
            fetchOneTask={fetchOneTask}
            setOneTask={setOneTask}
            isSelected={selectedVehicleId === vehicle._id}
            openVehicleForm={openVehicleForm}
          />
        ))}
    </>
  );
}

export default VehicleMarkers;
